<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/Page-header";
import vue2Dropzone from "vue2-dropzone";

/**
 * Starter component
 */
export default {
  data () {
    return {
      title: "文法小測驗",
      items: [
        {
          text: "法語鸚鵡螺",
          href: "/",
        },
        {
          text: "文法測驗第一層級",
          active: true,
        },
      ],
      type: 1,
      itemId: false,
      pluginItem: {
        id: "",
        image: "",
        title: "",
        des: ""
      },
      currentPage: 1,
      totalRows: 1,
      perPage: 15,
      pluginItems: [],
      dropzoneOptions: {
        url: process.env.VUE_APP_UPLD_URL + '/type/default',
        method: "post",
        uploadMultiple: false,
        paramName: "files[0]",
        maxFilesize: 2048,
        // headers: {
        //   "Authorization": 'Bearer ' + this.$root.auth_token,
        // },
        previewTemplate: this.template(),
      },
    };
  },
  components: {
    Layout,
    PageHeader,
    vueDropzone: vue2Dropzone,
  },
  created () {
    this.getPluginTypes()
  },
  methods: {
    getPluginTypes () {
      this.$root.apis.getPluginTypes(this.currentPage, this.processGetTypesSuccess)
    },
    processGetTypesSuccess (_response) {
      console.log("_response.body.data:", _response.body.items);

      this.currentPage = _response.body.page
      this.totalRows = _response.body.total
      this.perPage = _response.body.per_page
      this.pluginItems = _response.body.items
    },
    // 圖片上傳成功時
    uploadImageSuccess (file, response) {
      console.log("Upload Response:", response)
      this.pluginItem.image = response.data[0].url
      alert("檔案上傳成功！")
    },
    template: function () {
      return ` <div class="dropzone-previews mt-3">
            <div class="card mt-1 mb-0 shadow-none border">
                <div class="p-2">
                    <div class="row align-items-center">
                        <div class="col-auto">
                            <img data-dz-thumbnail src="#" class="avatar-sm rounded bg-light" alt="">
                        </div>
                        <div class="col pl-0">
                            <a href="javascript:void(0);" class="text-muted font-weight-bold" data-dz-name></a>
                            <p class="mb-0" data-dz-size></p>
                        </div>
                        <div class="col-auto">
                            <!-- Button -->
                            <a href="" class="btn btn-link btn-lg text-muted" data-dz-remove>
                                <i class="fe-x"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `;
    },
    createPlugin () {
      this.pluginItem = {
        id: "",
        image: "",
        title: "",
        des: ""
      }
      this.$bvModal.show('modal-responsive')
    },
    editorPlugin (_item) {
      this.pluginItem = _item
      this.$bvModal.show('modal-responsive')
    },
    editorContent (_item) {
      this.$router.push("/plugin/voices/items/" + _item.id)
    },
    createItem () {
      let vm = this
      this.$root.apis.createPluginType(this.pluginItem, function () {
        vm.$bvModal.hide('modal-responsive')
        vm.getPluginTypes()
      })
    },
    updateItem () {
      let vm = this
      let _item = this.pluginItem
      this.$root.apis.putTypeItem(_item.id, _item, function () {
        vm.$bvModal.hide('modal-responsive')
        vm.getPluginTypes()
      })
    },
    removeItem (_typeId) {
      if (!confirm("確認要刪除項目嗎？")) {
        return
      }
      this.$root.apis.delTypeItem(_typeId, this.getPluginTypes)
    },
    // 處理分頁切換
    onPageChange (page) {
      this.currentPage = page
      this.getPluginTypes()
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12 col-xl-12">
        <!-- Simple card -->
        <b-card>
          <div class="row">
            <div class="col-9"></div>
            <div class="col-3 text-right">
              <b-button variant="primary" type="button" @click="createPlugin">增加大題</b-button>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <!-- 分頁元件 - 靠右 -->
    <div class="row justify-content-end">
      <div class="col-auto">
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
          @change="onPageChange"></b-pagination>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-xl-3" v-for="(pluginItem, index) in pluginItems">
        <!-- Simple card -->
        <!-- require('@/assets/images/default-item-image.jpg') -->
        <b-card
          :img-src="$root.mediaUri + (pluginItem.image ? pluginItem.image : '/resources/images/default-item-image.jpg')"
          img-alt="Card image" img-top>
          <b-card-title>
            <h5 class="card-title">{{ pluginItem.title }}</h5>
          </b-card-title>
          <b-card-text>{{ pluginItem.des }}</b-card-text>
          <div class="row">
            <div class="col text-center">
              <b-button type="button" variant="primary" @click="editorPlugin(pluginItem)">設定</b-button>
            </div>
            <div class="col text-center">
              <b-button type="button" variant="primary" @click="editorContent(pluginItem)">編輯</b-button>
            </div>
            <div class="col text-center">
              <b-button type="button" variant="danger" @click="removeItem(pluginItem.id)">刪除</b-button>
            </div>
          </div>
        </b-card>
      </div>
      <!-- end col -->
    </div>

    <!-- 分頁元件 - 靠左 -->
    <div class="row">
      <div class="col-12">
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
          @change="onPageChange"></b-pagination>
      </div>
    </div>

    <b-modal id="modal-responsive" :title="(pluginItem.id) ? '編輯項目' : '新增項目'" title-class="font-18" body-class="p-4"
      hide-footer>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="field-1" class="control-label">標題</label>
            <input v-model="pluginItem.title" type="text" class="form-control" placeholder="" />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="field-2" class="control-label">簡述</label>
            <textarea v-model="pluginItem.des" class="form-control" placeholder="" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <vue-dropzone id="dropzone" ref="myVueDropzone" :use-custom-slot="true" :options="dropzoneOptions"
            @vdropzone-success="uploadImageSuccess">
            <div class="dz-message needsclick">
              <i class="h1 text-muted ri-upload-cloud-2-line"></i>
              <h3>拖移圖片檔案或點擊此視窗</h3>
              <span class="text-muted font-13">(僅限使用 JPEG / JPG / PNG 檔案)</span>
            </div>
          </vue-dropzone>
        </div>
      </div>
      <div class="text-center pt-3">
        <b-button type="button" @click="createItem" v-if="!pluginItem.id">建立</b-button>
        <b-button type="button" @click="updateItem" v-else>更新</b-button>
      </div>
    </b-modal>

  </Layout>
</template>
